<div class="form-styles">
    <h2 mat-dialog-title>Kinzy Offline</h2>
    <mat-dialog-content>The application can not be used until the API is available.</mat-dialog-content>
    <mat-dialog-actions>
        <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
        <button mat-flat-button color="primary" [mat-dialog-close]="true">Retry</button>
    </mat-dialog-actions>
</div>